const zh = {
  header: {
    tip1:
      "In order to prevent the system from accidentally closing the game in your virtual space, causing your game to be disconnected in unknown circumstances, you need to manually follow the following steps to complete the setting.",
  },
  content: {
    list1: {
      title:
        "When multi-process management state, add virtual master [lock] to keep the background running.",
    },
    list2: {
      title1:
        "Make sure the phone has enough memory. If the native machine runs out of memory, the system will automatically clean up the process. Even locked applications may be cleaned.",
      title2:
        "It is recommended that you take the initiative to clean up redundant background applications while running in virtual space.",
    },
  },
};

export default zh;
